/** Keep saved archived choices for reading, but omit them from edit drafts. */
export const editableValue = (field, value) => {
  if (value == null) {
    return value;
  }
  const active = new Set(
    (field.options || [])
      .filter((option) => !option.archived)
      .map((option) => String(option.id)),
  );
  if (field.field_type === "multi_select") {
    return value.filter((id) => active.has(String(id)));
  }
  if (field.field_type === "single_select") {
    return active.has(String(value)) ? value : null;
  }
  return value;
};

import { comparableValue } from "./types";

export const sameFieldValue = (field, left, right) => {
  if (field.field_type === "single_select") {
    return String(left ?? "") === String(right ?? "");
  }
  if (field.field_type === "multi_select") {
    return comparableValue(left ?? []) === comparableValue(right ?? []);
  }
  return comparableValue(left) === comparableValue(right);
};

/** Automatic archive removal is a save change, not a user edit to discard. */
export const hasEditableChanges = (definitions, original, draft) =>
  definitions.some(
    (field) =>
      field.editable &&
      !sameFieldValue(
        field,
        draft[field.id],
        editableValue(field, original[field.id]),
      ),
  );
